import { combineReducers } from "redux";
import todoReducer from "./todo/reducer";
import loginReducer from "../Pages/StashKar/Auth/Login/reducersLogin";
import dashboardReducer from '../Pages/StashKar/Dashboard/dashboardReducer';
import LegalReducer from '../Pages/StashKar/LegalAuth/legalreducer';
import connectBankReducer from "../Pages/StashKar/ConnectBank/connectBankReducer";
import personalInfoReducer from "../Pages/StashKar/PersonalInfo/personalInfoReducer";
import manualKycReducer from "../Pages/StashKar/ManualKycLink/manualKycReducer";
import adharCardReducer from "../Pages/StashKar/AdharCardKyc/adharCardReducer";
import investFundReducer from "../Pages/StashKar/InvestFund/investFundReducer";
import LenderAgreementReducer from "../Pages/StashKar/LenderAgreement/laReducer";
import tikectReducer from "../Pages/StashKar/FaqHelp/faqReducer";

const rootReducer = combineReducers({
  todo: todoReducer,
  login:loginReducer,
  dashboard: dashboardReducer,
  legalAuth: LegalReducer,
  connectBank:connectBankReducer,
  personalInfo:personalInfoReducer,
  manualKyc:manualKycReducer,
  adharCard:adharCardReducer,
  investFund:investFundReducer,
  lenderAgreement: LenderAgreementReducer,
  ticket:tikectReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;